'use client'
import React, { useState, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`

const fadeOut = keyframes`
    from { opacity: 1; }
    to { opacity: 0; }
`

const LoaderContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #0f172a;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    flex-direction: column;
    gap: 20px;
    
    &.fade-out {
        animation: ${fadeOut} 0.5s ease forwards;
        pointer-events: none;
    }
`

const Spinner = styled.div`
    width: 50px;
    height: 50px;
    border: 3px solid rgba(99, 102, 241, 0.3);
    border-radius: 50%;
    border-top-color: #6366f1;
    animation: ${spin} 1s ease-in-out infinite;
`

const LogoText = styled.div`
    font-family: 'Chakra Petch', sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    color: #fff;
    letter-spacing: 2px;
    text-transform: uppercase;
    opacity: 0.8;
`

export default function FontLoader({ children }) {
    const [isFontReady, setIsFontReady] = useState(false)
    const [shouldRender, setShouldRender] = useState(false)

    useEffect(() => {
        // Force minimum load time to prevent flickering if fonts load too fast
        const minLoadTimePromise = new Promise(resolve => setTimeout(resolve, 100))

        // Wait for fonts
        const fontLoadPromise = document.fonts ? document.fonts.ready : Promise.resolve()

        Promise.all([minLoadTimePromise, fontLoadPromise]).then(() => {
            setIsFontReady(true)
            // Wait for fade out animation
            setTimeout(() => {
                setShouldRender(true)
            }, 100)
        })
    }, [])

    if (shouldRender) {
        return children
    }

    return (
        <>
            <LoaderContainer className={isFontReady ? 'fade-out' : ''}>
                <Spinner />
                <LogoText>CONFIG STRIKE</LogoText>
            </LoaderContainer>

            {/* 
               Render children hidden so they mount and start fetching data/images,
               but user doesn't see the font jump.
            */}
            <div style={{ visibility: isFontReady ? 'visible' : 'hidden', opacity: isFontReady ? 1 : 0, transition: 'opacity 0.5s' }}>
                {children}
            </div>
        </>
    )
}
